import React from "react";
import { Router } from "react-router-dom";

import { onClientEntry as emotionOnClientEntry } from "gatsby-plugin-emotion/gatsby-browser";

import HideLoginOnTransition from "src/utils/HideLoginOnTransition";

import ConnectedWrapper from "./gatsby-utils/ConnectedWrapper";

export const replaceRouterComponent = ({ history }) => ({ children }) => (
  <Router history={history}>
    <ConnectedWrapper history={history}>
      <HideLoginOnTransition>{children}</HideLoginOnTransition>
    </ConnectedWrapper>
  </Router>
);

// See https://github.com/gatsbyjs/gatsby/issues/4021
export const onClientEntry = () => {
  emotionOnClientEntry();

  require("babel-polyfill");

  // IntersectionObserver polyfill for gatsby-image (Safari, IE)
  if (typeof window.IntersectionObserver === `undefined`) {
    require(`intersection-observer`);
    console.log(`👍 IntersectionObserver is polyfilled`);
  }

  // Object-fit/Object-position polyfill for gatsby-image (IE)
  const testImg = document.createElement(`img`);
  if (
    typeof testImg.style.objectFit === `undefined` ||
    typeof testImg.style.objectPosition === `undefined`
  ) {
    require(`object-fit-images`)();
    console.log(`👍 Object-fit/Object-position are polyfilled`);
  }
};



// WEBPACK FOOTER //
// ./gatsby-browser.js